<template>
	<payHeader></payHeader>
	<div class="buy-banner">
		<div class="main">
			<h1>云数据库 Memcached</h1>
			<p>云数据库Memcached是蓝队云提供的一种基于云端的高性能内存缓存服务，可有效加快应用速度，降低对后端数据库的性能依赖，<br>能够满足用户应用加速、高读写性能等多业务场景需求。</p>
		</div>
	</div>
	<div :class="fixedFlag ? 'pay-panel padding' : 'pay-panel'">
		<div class="container">
			<el-form :rules="rules" ref="ruleFormRef" :model="groupForm">
				<div class="buy-config-list">
					<p class="buy-config-name"><span style="margin-top: -25px">基础配置</span></p>
					<div class="buy-config-group">
						<label>区域</label>
						<ul class="ul-jifang">
							<li class="active">
								<p><span>云南昆明<em class="jf-hot">热</em></span>西南1区</p>
							</li>
						</ul>
						<div class="clear"></div>
					</div>
					<div class="buy-config-group">
						<label>版本</label>
						<ul class="ul-block">
							<li v-for="(item, index) in versionOptions" :key="index" @click="versionChange(index,item)" :class="{ 'active': selectedVersion === index }">{{item}}</li>
						</ul>
						<div class="clear"></div>
					</div>
					<dl class="otherData" v-show="version == '其他'">
						<dt>优势特性</dt>
						<dd>
							<span>多区域多节点</span>
							<span>高性能高可用</span>
							<span>灵活扩展、定制化部署</span>
							<span>数据安全</span>
							<span>满足合规要求</span>
							<span>多种RDS数据库可选择</span>
						</dd>
					</dl>
					<div v-show="version !== '其他'">
						<div class="buy-config-group" style="margin-bottom: 40px;">
							<el-table ref="tableRef" :data="tableData" highlight-current-row style="width: 100%" @current-change="handleCurrentChange">
								<el-table-column width="50">
									<span class="icon"></span>
								</el-table-column>
								<el-table-column prop="spec_name" label="规格" />
								<el-table-column sortable prop="cpu" label="CPU" />
								<el-table-column sortable prop="max_connections" label="最大连接数" />
								<el-table-column sortable prop="max_tps" label="最大吞吐量" />
								<el-table-column sortable prop="price" label="价格 / 月" />
							</el-table>
						</div>
						<div class="buy-config-group">
							<label>时长</label>
							<ul class="ul-block">
								<li v-for="(item, index) in groupedMonths" :key="index" @click="monthsChange(index,item.month,item.duration_discount)" :class="{ 'active': selectedMonths === index }">
									<p class="float-tip" v-if="item.duration_discount > 0">{{item.duration_discount / 10}}折<i></i></p>
									<i class="gift" v-if="item.duration_discount > 0"></i>
									{{item.duration}}
								</li>
							</ul>
							<div class="clear"></div>
						</div>
						<!-- <div class="add-btn"><el-checkbox v-model="bandwidthVisible" label="开通独享外网" size="large" style="color: #ff8a00;" @change="networkChange" /></div> -->
						<!-- <div class="buy-config-group" v-if="bandwidthVisible">
							<label>外网带宽</label>
							<div class="disk-item">
								<el-slider v-model="networkBandwidth" show-input :min="1" :max="30" :step="1" @change="networkBandwidthChange" />
								<ul class="drag-scale">
									<li style="left:-10px;">1M</li>
									<li style="left:65px;">5M</li>
									<li style="left:246px;">15M</li>
									<li style="left:432px;">25M</li>
									<li class="end" style="right:5px;">30M</li>
								</ul>
							</div>
							<span style="line-height: 30px;margin-left: 10px;">M</span>
							<div class="clear"></div>
						</div> -->
					</div>
				</div>
				<div class="buy-config-list" v-if="version !== '其他'">
					<p class="buy-config-name"><span style="margin-top: -25px">实例信息</span></p>
					<div class="buy-config-group input-form">
						<label>实例名称</label>
						<el-form-item prop="instance_name">
							<el-input v-model="groupForm.instance_name" autocomplete="off" placeholder="请输入实例名称" />
						</el-form-item>
						<div class="clear"></div>
					</div>
					<div class="buy-config-group input-form">
						<label>用户名称</label>
						<el-form-item>
							<el-input v-model="root" disabled />
						</el-form-item>
						<div class="clear"></div>
					</div>
					<div class="buy-config-group input-form">
						<label>设置密码</label>
						<el-form-item prop="instance_password">
							<el-input v-model="groupForm.instance_password" type="password" show-password minlength="8" autocomplete="off" placeholder="请输入初始密码" @blur="passwordblur" @change="passwordvalidate" />
							<div v-if="pwdTip" style="position: absolute;top: 25px;color: #888;font-size: 12px;">8-16个字符，至少包含小写字母、大写字母、数字和字符! @ % ^ *中的1种</div>
						</el-form-item>
						<div class="clear"></div>
					</div>
					<div class="buy-config-group input-form">
						<label>确认密码</label>
						<el-form-item prop="instance_password1">
							<el-input v-model="groupForm.instance_password1" type="password" show-password minlength="8" autocomplete="off" placeholder="请再次输入密码" />
						</el-form-item>
						<div class="clear"></div>
					</div>
					<div class="buy-config-group input-form">
						<label>实例备注</label>
						<el-form-item prop="instance_desc">
							<el-input v-model="groupForm.instance_desc" autocomplete="off" placeholder="请输入实例备注" />
						</el-form-item>
						<div class="clear"></div>
					</div>
				</div>
			</el-form>		
		</div>
		<div ref="configScrollY" v-show="version !== '其他'"></div>	
		<div :class="fixedFlag ? 'config-price fixed' : 'config-price'">
			<div class="container">
				<div class="price-parameter" v-if="version !== '其他'">
					<p>当前配置</p>
					<ul>
						<li>版本：<em>{{version == ''? '---':version}}</em></li>
						<li style="width: 480px;">规格：<em>{{specName}}（CPU：{{cpu}}核 | 内存：{{memoryShow}}）</em></li>
						<li style="width: 300px;">实例名称：<em>{{groupForm.instance_name == '' ? '---':groupForm.instance_name}}</em></li>
						<li>购买量：<em>{{months}}个月 x 1台</em></li>
						<li v-if="bandwidthVisible">外网带宽：<em>{{networkBandwidth}}M</em></li>
					</ul>
				</div>
				<div class="price-buy" v-if="version == '其他'">
					<div class="price-info">配置费用：￥<span class="price">10万</span>/年起</div>
					<a href="https://www.landui.com/index/index/qq.html" target="_blank" class="btn-buy">咨询客服</a>
				</div>
				<div class="price-buy" v-else>
					<div class="price-info">配置费用：￥<span class="price">{{totalPrice}}</span>
						<span v-if="discountPrice !== '0'">
							<del>原价：<span>{{originPrice}}</span>元</del>
							<span class="discount">优惠：<em>{{discountPrice}}</em> 元</span>
						</span>
						<div class="auto">
							<el-checkbox v-model="autoRenewalVisible" label="启用自动续费" size="large" style="color: #ff8a00;" @change="autoRenewalChange" /><span v-if="autoRenewalVisible">续费周期为 {{autoRenewal}} 个月（请保障账户余额充足以免扣款失败）</span>
						</div>
					</div>
					<el-button type="warning" class="btn-buy" :disabled=submitDisabled @click="submitForm(ruleFormRef)">{{submitText}}</el-button>
					<div class="agree">
						<el-checkbox v-model="agreeVisible" size="large" @change="agreeChange" />
						<span style="margin-left:8px;display: inline-block;vertical-align: text-top; margin-top: -2px;">我已经阅读并同意<a href="https://www.landui.com/docs-11954" target="_blank">《蓝队云云数据库服务协议》</a></span>
					</div>
				</div>
			</div>
		</div>
	</div>
	<payFooter></payFooter>
	<login v-model:show="isModalOpen" @loginBuy="handleloginBuy" @loginClose="handleCloseModal"></login>
</template>

<script setup>
	import {ref, reactive,inject,onMounted,onUnmounted,watch} from "vue";
	import {useStore} from 'vuex'
	import { payHeader,payFooter } from 'landui-ui';
	import { ElMessageBox } from 'element-plus'
	import { isLogin,getVersion,duration,getSpec,priceCalculation,pay} from '@/api/home';
	import login from '../../components/login.vue'
	
	let removeScrollListener;
	const domain = inject('domain');
	const submitText = ref('立即购买');
	const submitDisabled = ref(true);
	const agreeVisible = ref(false);
	const isModalOpen = ref(false);
	const autoRenewal = ref(1);
	const autoRenewalVisible = ref(true);
	const bandwidthVisible = ref(false);
	const networkStatus = ref(1);
	const networkBandwidth = ref(1);
	const configScrollY = ref(null);
	const fixedFlag = ref(false);
	const store = useStore()
	const root = ref('root');
	const pwdTip = ref(true);
	const exampleType = ref('');
	const exclusiveData = ref('');
	const highData = ref('');
	const selectedType = ref(0);
	const selectedMonths = ref(0);
	const selectedVersion  = ref(0);
	const totalPrice = ref('0');
	const originPrice = ref('0');
	const discountPrice = ref('0');
	const cpuPrice = ref('0');
	const tableData = ref();
	const bandwidthPrice = ref('0');
	const versionOptions = ref('');
	const specName = ref('');
	const version = ref('');
	const cpu = ref('1');
	const memory = ref('1');
	const memoryShow = ref('1');
	const bandwidth = ref('1');
	const months = ref('1');
	const specId = ref('');
	const discount = ref(0);
	const monthsData = ref([]);
	const groupedMonths = ref([]);
	const tableRef = ref(null);
	const currentRow = ref('');
	const ruleFormRef = ref(null);
	const groupForm = ref({instance_name:'',instance_password:'',instance_password1:'',instance_desc:'',months:''});
	const passValidate = (rule, value, callback) => {
	  if (/^(?=.*[A-Z])(?=.*[a-z])(?=.*[0-9])(?=.*[!@%^*])[^#&$~)(_+=,`.'}{|:";\\[?><]{8,16}$/.test(value)) {
	    callback()
	  }else{
	  	callback(new Error('8-16个字符，至少包含小写字母、大写字母、数字和字符! @ % ^ *中的1种'))
	  }
	};
	const passValidate1 = (rule, value, callback) => {
		if (value === '') {
			callback(new Error('请再次输入密码'))
		} else if(value !== groupForm.value.instance_password){
			callback(new Error('两次填写的密码不一致'))
		} else {
			  callback()
		}
	};
	const passwordblur = () => {
		if(groupForm.value.instance_password == ''){
			pwdTip.value = false
		}
	}
	const passwordvalidate = () =>{
		ruleFormRef.value.validateField('instance_password',(valid) => {
			if(valid){
				pwdTip.value = true
			}else{
				pwdTip.value = false
			}
		})
	}
	const rules = reactive({
		instance_name: [
			{ required: true, message: '请填写实例名称', trigger: 'blur' },
		],
		instance_password: [
			{ required: true, message: '8-16个字符，至少包含小写字母、大写字母、数字和字符! @ % ^ *中的1种', trigger: 'blur' },
			{ validator: passValidate, trigger: 'blur' }
		],
		instance_password1: [
			{ required: true, message: '请再次输入密码', trigger: 'blur' },
			{ validator: passValidate1, trigger: 'blur' }
		],
		instance_desc: [
			{ required: true, message: '请填写实例备注', trigger: 'blur' },
		]
	});
	const generateData = () => {
		getVersion().then((res) => {
			let arr = res.data;
			arr.push('其他')
			versionOptions.value = arr;
			version.value = res.data[0];
		});
		getSpec().then((res) => {
			exclusiveData.value = res.data.standalone_list;
			highData.value = res.data.master_slave_list;
			tableChange('0',res.data.standalone_list)
		})
		duration().then((res) => {
			monthsData.value = JSON.parse(res.data.config);
			groupedMonths.value = JSON.parse(res.data.config)['single_node'];
			discount.value = JSON.parse(res.data.config)['single_node'][0].duration_discount;
		})
		isLogin().then((res) => {
			if(res.code === 200){
				store.commit("setLogin", true)
				store.commit("setUserName", res.data.username)
			}
		});
	};
	const tableChange = (key,data) => {
		tableData.value = data;
		tableRef.value.setCurrentRow(data[0]);
		cpu.value = data[0].cpu;
		memory.value = data[0].memory;
		memoryShow.value = data[0].memcache_memory;
		cpuPrice.value = data[0].price;
		specId.value = data[0].specifications_id;
		specName.value = data[0].spec_name;
		exampleType.value = key;
	}
	const versionChange = (key,value) => {
		selectedVersion.value = key;
		version.value = value;
	};
	const bandwidthChange = (value) => {
	  bandwidth.value = value;
	  priceChange();
	};
	const monthsChange = (key,value,yh) => {
	  selectedMonths.value = key;
	  months.value = value;
	  discount.value = yh;
	  if (autoRenewalVisible.value) {
	  	autoRenewal.value = parseInt(value) >= 12 ? 12 : 1;
	  }
	  priceChange();
	};
	const autoRenewalChange = () => {
		if (autoRenewalVisible.value) {
			autoRenewal.value = parseInt(months.value) >= 12 ? 12 : 1;
		} else{
			autoRenewal.value = 0
		}
	}
	const agreeChange = (val) => {
		submitDisabled.value = val ? false : true;
	}
	const networkChange = () => {
		networkStatus.value = bandwidthVisible.value ? 2 : 1;
		priceChange();
	}
	const networkBandwidthChange = (value) => {
	  networkBandwidth.value = value;
	  priceChange();
	};
	const handleCurrentChange = (val) => {
		currentRow.value = val;
		cpu.value = val.cpu;
		memory.value = val.memory;
		memoryShow.value = val.memcache_memory;
		cpuPrice.value = val.price;
		specId.value = val.specifications_id;
		specName.value = val.spec_name;
		priceChange();
	}
	const priceChange = () => {
		const param = {
			'month':parseInt(months.value),
			'specifications_id':specId.value,
			'enable_public_network':networkStatus.value
		};
		if (networkStatus.value == 2) {
			param['public_network_bandwidth'] = networkBandwidth.value;
		}
		priceCalculation(param).then((res) => {
			totalPrice.value = res.data.price;
			originPrice.value = res.data.original_price;
			discountPrice.value = res.data.discount_price;
		})
	};
	const submitForm = () => {
		if (!ruleFormRef.value) return;
		ruleFormRef.value.validate((valid) => {
			if (valid) {
				submitDisabled.value = true;
				submitText.value = "正在提交";
				groupForm.value.cpu = JSON.stringify(cpu.value);
				groupForm.value.memory = JSON.stringify(memory.value);
				groupForm.value.bandwidth = bandwidth.value;
				groupForm.value.instance_version = version.value;
				groupForm.value.months = months.value;
				groupForm.value.instance_type = 0;
				groupForm.value.instance_slave_number = 1;
				groupForm.value.specifications_id = specId.value;
				groupForm.value.enable_public_network  = networkStatus.value;
				groupForm.value.auto_renewal_months = autoRenewal.value;
				const param = groupForm.value;
				if (networkStatus.value == 2) {
					param['public_network_bandwidth'] = networkBandwidth.value;
				}
				pay(param).then((res) => {
					if(res.code === 202){
						submitDisabled.value = false;
						submitText.value = "立即购买";
						isModalOpen.value = !isModalOpen.value;
					}else if(res.code === 205){
						window.location.href = domain+"/user/verifynew/index.html";
					}else if(res.code === 200){
						if (res.data.id == '') {
							ElMessageBox.alert('下单失败', '温馨提示', {
								customClass: 'error-box',
								showConfirmButton: false,
								callback: action => {
								      
								}
							})
						} else{
							window.location.href = domain+"/user/orders/changestype.html?id="+res.data.id;
						}
					}else{
						submitDisabled.value = false;
						submitText.value = "立即购买";
					}
				})
			} else {
				pwdTip.value = false
			  return false;
			}
		});
	};
	const handleCloseModal = (val) => {
		isModalOpen.value = val;
	}
	const handleloginBuy = (val) => {
		if(val){
			submitForm()
		}
	}
	const handleScrollF = () => {
		if (configScrollY.value) {
			const handleScroll = (event) => {
				const distanceFromTop = configScrollY.value.getBoundingClientRect().top + window.scrollY - window.innerHeight + 373;
				const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
				if(scrollTop >= distanceFromTop) {
					fixedFlag.value = false
				}else{
					fixedFlag.value = true
				}
			};
			window.addEventListener('scroll', handleScroll, { passive: true });
			  // 定义一个函数用于移除滚动事件监听器，并将其赋值给一个变量，以便在卸载时调用
			removeScrollListener = () => {
				window.removeEventListener('scroll', handleScroll);
			};
		}
	}
	
	watch(() => version.value,(newValue) => {
	    if (newValue == '其他') {
			fixedFlag.value = false
	    	removeScrollListener();
	    }else{
			handleScrollF()
		}
	});
	
	onMounted(() => {
		generateData();
		handleScrollF()
	});
	onUnmounted(() => {
		if (removeScrollListener) {
			removeScrollListener();
		}
	});
	
</script>

<style scoped>
	.container{width: 1280px; margin: 0 auto;}
	.add-btn{ margin-left: 99px;margin-bottom: 20px; cursor: pointer;}
	.otherData{ width: 100%; border: 1px solid #ebeef5;text-align: center; margin-bottom: 16px; overflow: hidden;}
	.otherData dt{background-color: #ecf5ff;padding: 10px; font-size: 14px;}
	.otherData dd{line-height: 70px; overflow: hidden;}
	.otherData span{ margin:0 20px; padding-left: 25px;background: url(../../assets/images/no.png) left center no-repeat;}
	.pay-panel{padding-bottom: 40px; overflow: hidden;}
	.pay-panel.padding{padding-bottom: 400px;}
	.el-input-number{margin-right: 8px;}
	.buy-config-name{ width:50px; background: #f2f5fa; color: #999999; font-size: 16px; position: absolute; left: 0; top: 0; bottom: 0; }
	.buy-config-name span{ position: absolute; left:14px; top:50%; margin-top: -40px; line-height: 18px; display: block; width:22px; text-align: center;}
	.buy-config-list{position: relative;padding:30px 30px 15px 80px; border: 1px solid #dddddd; margin-top:30px;}
	.buy-config-list:hover{ border: 1px solid #015bfe;}
	.buy-config-list:hover .buy-config-name{ background: #015bfe; color: #fff; }
	.buy-config-group{margin: 0 0 18px;}
	.buy-config-group label {width:100px;line-height: 35px;float: left;}
	.buy-config-group .gift {display: inline-block;vertical-align: text-top;margin-right: 5px;width: 17px;height: 17px;background: url(../../assets/images/gift.png) center no-repeat;}
	.float-tip { display: none;border: 1px solid #ff8a00;color: #ff8a00;line-height: 18px;font-size: 12px;background: #fff;text-align: center;padding: 7px 10px;position: absolute;left: -100px;right: -100px;z-index: 11;}
	.float-tip i {display: block;width: 10px;height: 7px;position: absolute;left: 50%;margin-left: -5px;bottom: -6px;background: url(../../assets/images/duration.png) center bottom no-repeat;}
	.ul-block{ padding-left: 100px;}
	.ul-block li{width: 120px;height: 33px; float: left; line-height: 32px; text-align: center; background: #f2f5fa;border: 1px solid #ddd; margin-right: -1px; margin-bottom: 2px; position:relative; cursor: pointer;}
	.ul-block .active{ background: #015bfe; border: 1px solid #015bfe; color: #fff; }
	.ul-block .float-tip {bottom: 42px;left: -15px;right: -15px;padding: 7px 5px;}
	.ul-block li:hover .float-tip{ display: block;}
	.ul-jifang .jf-hot {position: absolute;right: -1px;top: -1px;background: #ff8a00;font-size: 12px;line-height: 15px;height: 16px;padding: 0 2px;text-align: center;color: #fff;}
	.ul-jifang li{position: relative;font-size: 12px; color: #999999;float: left; height: 65px; text-align: center; border: 1px solid #dddddd; margin:0 -1px 2px 0; cursor: pointer;}
	.ul-jifang li span{ display: block; font-size: 14px; color: #333; height: 33px; line-height: 33px; width: 105px; margin: 0 0 7px; border-bottom: 1px solid #ddd; background: #f2f5fa;}
	.ul-jifang .active{color: #015bfe; border: 1px solid #015bfe; z-index: 1; }
	.ul-jifang .active span{ color: #fff; background: #015bfe; border-bottom: 1px solid #015bfe; }
	.config-price {padding-top: 30px;}
	.config-price.fixed{position: fixed;left: 0;right: 0;bottom: 0; z-index: 7;}
	.config-price .container{border: 1px solid #ddd;background: #fff;overflow: hidden;}
	.price-parameter{padding: 35px 40px 15px;border-bottom: 1px dashed #dddddd;overflow: hidden;}
	.price-parameter p {font-size: 16px;line-height: 30px;}
	.price-parameter p span {float: right;width: 78px;font-size: 14px;height: 28px;line-height: 28px;text-align: center;color: #999999;cursor: pointer;border: 1px solid #ddd;background: #f2f5fa;}
	.price-parameter p span::after{content: "";display: inline-block;margin-left: 5px; width: 12px;height: 9px;background: url(../../assets/images/drop.png) center no-repeat;transition: transform 0.3s ease;}
	.price-parameter p .open:after {transform: rotate(180deg);}
	.price-parameter ul {margin: 20px 10px 20px 0;overflow: hidden;}
	.price-parameter ul li {float: left;width: 260px;color: #999999;line-height: 30px;}
	.price-parameter ul em{color: #666}
	.price-parameter .wh {width: 360px !important;}
	.price-buy{padding: 35px 40px; overflow: hidden;}
	.price-buy .price-info{ float: left; color: #666666; margin-top: -10px;}
	.price-buy .price-info .price{ font-size: 30px; color: #ff8a00; font-weight:bold; }
	.price-buy .price-info del {color: #888;margin-left: 10px;}
	.price-buy .price-info .discount{margin-left: 40px; padding-left: 28px; background: url(../../assets/images/yh.png) left center no-repeat;}
	.price-buy .price-info em{color: #005bff;}
	.price-buy .agree{ clear: both; float: right; margin-top: 10px;}
	.price-buy .auto{display: inline-block; vertical-align: middle; margin:-3px 0 0 30px;}
	.price-buy .auto span{margin-left: 5px;display: inline-block;vertical-align: middle;margin-top: -7px;}
	.price-buy .btn-buy{ width: 140px;height:40px; line-height: 40px;font-size: 14px; text-align: center; color: #fff; border-radius: 0;background-color: #ff8a00; float: right; cursor: pointer;}
	.price-buy .btn-buy:hover{ background:#fb8b2a;}
	.price-buy .btn-buy.is-disabled{background-color: #f3d19e;}
	.input-form{margin: 0;}
	.disk-item{position: relative; float: left; margin-bottom: 18px; margin-left: 9px;}
	.drag-scale{position: absolute;left: 0; top: 20px; width: 558px;}
	.drag-scale li{position: absolute;top: 0;height: 35px;line-height: 50px;font-size: 12px;}
	.drag-scale li:before {content: "";display: block;position: absolute; left: 50%;top: 0;width: 1px;height: 10px; background: #dddddd;}
	.icon{ display: block; width: 16px;height: 16px;background: url(../../assets/images/radio-normal.png) center no-repeat;}
	.current-row .icon{background: url(../../assets/images/radio-checked.png) center no-repeat;}
	::v-deep(.el-slider) {width: 700px; float:left;}
	::v-deep(.el-slider__button-wrapper){background: url(../../assets/images/slider.png) center no-repeat;}
	::v-deep(.el-slider__runway){height: 8px;background-color: #e6ebf4;}
	::v-deep(.el-slider__bar){height: 8px;}
	::v-deep(.el-slider__button){ border: 0;background-color: transparent;}
	::v-deep(.el-input-number .el-input) {width: 100% !important;}
</style>